// extracted by mini-css-extract-plugin
module.exports = {"modal-content":"Ready_modal-content_3hKYm"};